import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { NewbuildingFlatTourBookingNotification } from '../../components/NewbuildingFlatTourBookingNotification';
import {
  getFlatTourBookingStatusDescription,
  getIsFlatTourBookingTooltipVisible,
} from '../../selectors/newbuildingFlatTourBooking';
import { toggleFlatTourBookingNotification } from '../../serp/state/flatTourBooking';

export const NewbuildingFlatTourBookingNotificationContainer: React.FC = () => {
  const dispatch = useDispatch();

  const isVisible = useSelector(getIsFlatTourBookingTooltipVisible);
  const description = useSelector(getFlatTourBookingStatusDescription);

  const handleClose = React.useCallback(() => {
    dispatch(toggleFlatTourBookingNotification(false));
  }, [dispatch]);

  if (!isVisible) {
    return null;
  }

  return <NewbuildingFlatTourBookingNotification onClose={handleClose} description={description} />;
};
